import {useRef} from "react";
import Sidebar from "./layouts/Sidebar";
import Main from "./layouts/Main";
import UKRibbon from "./layouts/UKRibbon";
import AppTitle from "./layouts/AppTitle";
import Year from "./Year";
import QueryLayer from "./QueryLayer";
import SelectPollutantMetric from "./pollutant-metric";
import ZoneLaList from "./ZoneLaList";
import Breadcrumb from "./components/Breadcrumb";
import MapGallery from "./esri-components/MapGallery";
import MapSearch from "./esri-components/MapSearch";
import {ACTIVE_HIGHLIGHT_LINE_ID, MAP_OPTIONS} from "./settings";
import {useEsriLoader} from "./hooks/useEsriLoader";
import {FieldDataProvider} from "./providers/FieldDataContext";
import {EsriProvider} from "./providers/EsriContext";
import {FormProvider, useForm} from "react-hook-form";
import FormWizard from "./components/Wizard";

import {AboutProvider} from "./requested-information/About";
import {Info} from "./requested-information/Info";


const additionalModules = [
  { path: "esri/Graphic", name: "Graphic" },
  { path: "esri/layers/GraphicsLayer", name: "GraphicsLayer" },
  { path: "esri/Color", name: "Color" },
  { path: "esri/symbols/SimpleLineSymbol", name: "SimpleLineSymbol" },
  { path: "esri/symbols/SimpleFillSymbol", name: "SimpleFillSymbol" },
  { path: "esri/symbols/SimpleMarkerSymbol", name: "SimpleMarkerSymbol" },
  { path: "esri/identity/IdentityManager", name: "IdentityManager" },
  { path: "esri/tasks/Geoprocessor", name: "Geoprocessor" },
];

const App = () => {
  const mapRef = useRef();
  const { esriLoader } = useEsriLoader(
    mapRef,
    MAP_OPTIONS,
    additionalModules,
    ACTIVE_HIGHLIGHT_LINE_ID
  );
  const methods = useForm();

  return (
    <FieldDataProvider>
      <EsriProvider esriLoader={esriLoader}>
        <FormProvider {...methods}>
          <div className="app overflow-hidden h-screen">
            <FormWizard/>
            <UKRibbon />
            <div className="flex flex-1 container-height">
              <Sidebar>
                <AppTitle />
                <hr className="border-blue-700" />
                <Breadcrumb
                  back={<a href="/compliance-data">Compliance Data</a>}
                  current={<a href="/data/compliance-map">Compliance Map</a>}
                />
                <hr className="border-blue-700" />
                <div className="px-3 py-3">
                  <Year />
                  <QueryLayer />
                  <SelectPollutantMetric />
                  <ZoneLaList />
                  <MapGallery />
                  <button
                    onClick={() => {
                      window.location.reload();
                    }}
                    className="bg-blue-600 w-full hover:bg-blue-400 border-blue-700 hover:border-blue-500 text-white font-bold mt-3 py-2 px-4 rounded"
                  >
                    Reset Map Selections
                  </button>
                </div>
              </Sidebar>
                <Main>
                  <MapSearch />
                  <AboutProvider>
                    <Info/>
                  </AboutProvider>
                  <div
                    data-testid="webmap_canvas-test"
                    className="webmap"
                    ref={mapRef}
                    style={{ height: "100%" }}
                  />
                </Main>
            </div>
          </div>
        </FormProvider>
      </EsriProvider>
    </FieldDataProvider>
  );
}

export default App;
